import { useSessionStore } from '@/common/stores/sessionStore'

export const privateNumberValues: (string | null)[] = ['Hidden number', 'Unavailable', 'Anonymous', 'No caché', 'Anonyme', 'Private', '-', '']

// format any phone numbers (and private) to E.164 format
export const formatPhoneNumber = (phoneNumber: string | null | undefined): string | null => {
  const regexE164 = /^\+[1-9]\d{1,14}$/
  const regexStartWith2Digits = /^\d{2}/
  const regexStartWithZeroAndAnotherDigit = /^0[1-9]/
  const MIN_E164_LENGTH = 8
  const sessionStore = useSessionStore()

  if (!phoneNumber || privateNumberValues.includes(phoneNumber)) {
    return null
  }

  const cleanedPhoneNumber = phoneNumber.trim().replaceAll(/\s+/g, '')

  if (cleanedPhoneNumber.length < MIN_E164_LENGTH) {
    console.error('-sensitive-information-', `Phone number <${phoneNumber}> is below minimum length`)
    return null
  }

  if (regexE164.test(cleanedPhoneNumber)) {
    return cleanedPhoneNumber
  }

  if (cleanedPhoneNumber.startsWith('00')) {
    return formatPhoneNumber(cleanedPhoneNumber.replace('00', '+'))
  }

  if (regexStartWithZeroAndAnotherDigit.test(cleanedPhoneNumber)) {
    return cleanedPhoneNumber.replace('0', '+' + sessionStore.defaultCountryPhoneCode)
  }

  if (regexStartWith2Digits.test(cleanedPhoneNumber)) {
    return `+${cleanedPhoneNumber}`
  }

  console.error('-sensitive-information-', `Invalid phone number ${phoneNumber}`)
  return null
}
